import { render, staticRenderFns } from "./FinishStudent.vue?vue&type=template&id=54a83b36&"
import script from "./FinishStudent.vue?vue&type=script&lang=js&"
export * from "./FinishStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports